module.exports = __webpack_public_path__ + "static/category-page-2-0e0bc4b1b777e9c59b94dcf5a94e3088.png";